import { render, staticRenderFns } from "./syncProduct.vue?vue&type=template&id=5cf5bdba&scoped=true"
import script from "./syncProduct.vue?vue&type=script&lang=js"
export * from "./syncProduct.vue?vue&type=script&lang=js"
import style0 from "./syncProduct.vue?vue&type=style&index=0&id=5cf5bdba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf5bdba",
  null
  
)

export default component.exports